import React, { useEffect } from 'react'
import CaptchaModal from 'src/components/CaptchaModal'
import useLocation from 'src/hooks/useLocation'
import { useAppDispatch, useAppSelect } from 'src/hooks/useRedux'

import RenderCardSearchResults from './components/RenderCardSearchResults'
import {
  closeCaptchaModal,
  setCaptchaToken,
  setPayload,
} from './ducks/home.reducer'
import { SmartCheckForm } from './components'

const HomePage: React.FC = () => {
  const { payload, captchaModalOpen } = useAppSelect((state) => state.home)
  const dispatch = useAppDispatch()
  const { location } = useLocation()

  // Set location on load page for the first time.
  useEffect(() => {
    if (!location?.latitude || !location.longitude) return

    if (!payload.longitude || !payload.latitude) {
      dispatch(setPayload({ ...payload, ...location }))
    }
  }, [location])

  return (
    <>
      <SmartCheckForm />
      <RenderCardSearchResults />
      <CaptchaModal
        open={captchaModalOpen}
        onToken={(token) => {
          dispatch(setCaptchaToken(token))
          dispatch(closeCaptchaModal())
        }}
        onClose={() => {
          dispatch(closeCaptchaModal())
        }}
      />
    </>
  )
}

export default HomePage
